import { useFormik } from "formik";
import * as yup from "yup";
import { Box, Button, Container, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import { ProgressBar } from "@components/ProgressBar";
import CustomRightImage from "@components/CustomRightImagev2";
import { InactivityHandler } from "@components/InactivityHandler";
import useTofuSteps from "@hooks/useTofuSteps";

const SCREEN_STATUS = "CSIP2";

const InformacionPlataforma2 = () => {
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md"));
  const { numberOfSteps, currentStep } = useTofuSteps(SCREEN_STATUS);

  const formik = useFormik({
    initialValues: {
      tipoEmpleo: "" as string,
    },
    validationSchema: yup.object().shape({
      tipoEmpleo: yup.string(),
    }),
    onSubmit: async () => {
      // Maqueta: por ahora solo validamos la UI.
    },
    validateOnMount: true,
  });

  return (
    <Grid container height="100%">
      <Grid item xs={12} md={8} mt={2}>
        <InactivityHandler />
        <Box
          sx={{
            mt: 2,
            mx: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography
            variant={isMobileOrTablet ? "h4" : "h3"}
            fontWeight={500}
            textAlign="center"
            color={"primary.dark"}
          >
            Información de tu Plataforma
          </Typography>

          <Container maxWidth="sm" sx={{ mt: isMobileOrTablet ? 2 : 3 }}>
            <ProgressBar totalSteps={numberOfSteps} currentStep={currentStep} />
          </Container>

          <Container maxWidth="sm" sx={{ mt: isMobileOrTablet ? 2 : 3 }}>
            <form onSubmit={formik.handleSubmit} noValidate>
              <Typography
                textAlign="center"
                color="text.primary"
                fontWeight={500}
                sx={{ mb: 2 }}
                variant={isMobileOrTablet ? "body2" : "body1"}
              >
                Conecta con los datos de tu plataforma
              </Typography>
              <Box
                sx={{
                  borderWidth: 1,
                  borderStyle: "dashed",
                  borderColor: "divider",
                  borderRadius: 2,
                  padding: 2,
                  cursor: "pointer",
                  my: 5,
                  height: "100px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Typography variant="h6" fontWeight={700} color="primary.dark">
                  Aca va el widget...
                </Typography>
              </Box>
              <Box display="flex" justifyContent="center" mt={isMobileOrTablet ? 2 : 3} mb={2}>
                <Button type="submit" variant="default" disabled={!formik.isValid || formik.isSubmitting}>
                  Continuar
                </Button>
              </Box>
            </form>
          </Container>
        </Box>
      </Grid>

      {!isMobileOrTablet && (
        <Grid item xs={12} md={4}>
          <CustomRightImage />
        </Grid>
      )}
    </Grid>
  );
};

export default InformacionPlataforma2;
